import { InputComponentType } from "../../utils/enums";

export const applicantGeneralFields = [
  {
    name: "yearApplied",
    label: "Application Period",
    component: InputComponentType.FreeTextDropdown,
    md: 3,
  },
  {
    name: "status",
    label: "Status",
    component: InputComponentType.Dropdown,
    md: 3,
  },
  {
    name: "__row_break_1",
    isBreak: true,
  },
  {
    name: "__row_photo_1",
    isPhoto: true,
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true,
    component: InputComponentType.TextField,
  },
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    required: true,
    component: InputComponentType.TextField,
  },
  {
    name: "middleName",
    label: "Middle Name",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "suffix",
    label: "Suffix",
    type: "text",
    component: InputComponentType.Dropdown,
  },
  {
    name: "race",
    label: "Race",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "gender",
    label: "Sex",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "ethnicity",
    label: "Ethnicity",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "dob",
    label: "DOB",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "ssn",
    label: "SSN",
    type: "text",
    component: InputComponentType.TextField,
    isSSN: true,
    md: 2,
  },
  {
    name: "maritalStatus",
    label: "Marital Status",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "address",
    label: "Address",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "city",
    label: "City",
    type: "text",
    component: InputComponentType.Dropdown,
    startIcon: true,
  },
  {
    name: "state",
    label: "State",
    component: InputComponentType.Dropdown,
  },
  {
    name: "zip",
    label: "Zip",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "phone",
    label: "Phone",
    type: "text",
    component: InputComponentType.TextField,
    isPhoneNumber: true,
  },
  {
    name: "workPhoneNum",
    label: "Work Phone",
    type: "text",
    component: InputComponentType.TextField,
    isPhoneNumber: true,
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "education",
    label: "Education",
    component: InputComponentType.Dropdown,
  },
  {
    name: "comments",
    label: "Comments",
    type: "text",
    component: InputComponentType.TextField,
    md: 12,
  },
  {
    name: "militaryRelatedNotes",
    label: "Military Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 12,
  },
];

export const applicantTestFields = [
  {
    name: "pat",
    label: "PAT",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "patDate",
    label: "PAT Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "patNotes",
    label: "PAT Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "written",
    label: "Written",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "writtenDate",
    label: "Written Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "writtenNotes",
    label: "Written Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "background",
    label: "Background",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "backgroundDateSent",
    label: "Background Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "backgroundNotes",
    label: "Background Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 3,
  },
  {
    name: "backgroundInvestigator",
    label: "Investigator",
    type: "text",
    component: InputComponentType.TextField,
    md: 1,
  },
  {
    name: "backgroundDateReturned",
    label: "Background Date Returned",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "boxNum",
    label: "File Location",
    type: "text",
    component: InputComponentType.TextField,
    md: 2,
  },
  {
    name: "oralCommittee",
    label: "First Interview",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "oralCommitteeDate",
    label: "First Interview Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "oralCommitteeNotes",
    label: "First Interview Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "oralDirector",
    label: "2nd Interview",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "oralDirectorDate",
    label: "2nd Interview Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "oralDirectorNotes",
    label: "2nd Interview Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "medical",
    label: "Medical Exam",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "medicalDate",
    label: "Medical Exam Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "medicalNotes",
    label: "Medical Notes",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "polygraph",
    label: "Polygraph",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "polygraphDate",
    label: "Polygraph Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "polygraphNotes",
    label: "Polygraph Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "psych",
    label: "Psychological Exam",
    component: InputComponentType.Dropdown,
    md: 2,
  },
  {
    name: "psychDate",
    label: "Psychological Exam Date",
    component: InputComponentType.DatePicker,
    md: 2,
  },
  {
    name: "psychNotes",
    label: "Psychological Notes",
    type: "text",
    component: InputComponentType.TextField,
    md: 8,
  },
  {
    name: "testNotes",
    label: "Comments",
    component: InputComponentType.TextField,
    md: 12,
  },
  {
    name: "eligibility",
    label: "Eligibility",
    component: InputComponentType.Checkbox,
  },
];
